import styled from "@emotion/styled";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${({ theme }) => theme.spacing["5"]};
  align-items: stretch;
  gap: ${({ theme }) => theme.spacing["3"]};
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  background: ${({ theme }) => theme.colors.surface.pane};
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: ${({ theme }) => theme.spacing["2"]} 0;
  justify-content: center;
  align-items: center;
`;

export const StyledHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: ${({ theme }) => theme.spacing["2"]};
`;

export const StyledHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["1"]};
`;

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const StyledExpandedContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: ${({ theme }) => theme.spacing["10"]};
`;
